import React, { useState } from "react";
import Classrooms from "./Tabs/Classrooms";
import Levels from "./Tabs/Levels";
import Options from "./Tabs/Options";
import Topics from "./Tabs/Topics";
import Years from "./Tabs/Years";

const tabs = ["Années", "Niveaux", "Classes", "Options", "Matières"];
const Settings = () => {
	const [index, setIndex] = useState<number>(4);
	return (
		<div className="setting-page">
			<h1>Paramètres</h1>
			<ul className="flex items-center gap-4 mt-5">
				{tabs?.map((tab, i) => (
					<li
						key={tab + i}
						className={` ${i === index && "text-orange-500"}`}
						role="button"
						onClick={() => setIndex(i)}
					>
						{tab}
					</li>
				))}
			</ul>
			<div className="tabs-container pt-5">
				{index === 0 && <Years />}
				{index === 1 && <Levels />}
				{index === 2 && <Classrooms />}
				{index === 3 && <Options />}
				{index === 4 && <Topics />}
			</div>
		</div>
	);
};

export default Settings;
